module.exports = __webpack_public_path__ + "media/applicants/shopper-safety-mobile-3bfe46d8.webp";